import { Link } from 'react-router-dom'
import { Album } from '../../types/album'
import { Image, FolderOpen } from 'lucide-react'
import { getThumbnailUrl } from '../../lib/images'
import { formatDateRange } from '../../lib/dateRange'

interface AlbumCardProps {
  album: Album
}

export const AlbumCard = ({ album }: AlbumCardProps) => {
  const coverSrc = album.coverThumbnailKeys
    ? getThumbnailUrl({ thumbnailKeys: album.coverThumbnailKeys, updatedAt: album.updatedAt }, 'medium')
    : undefined
  
  return (
    <Link
      to={`/album/${album.albumId}`}
      className="group block bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
    >
      {/* Cover Image */}
      <div className="aspect-[4/3] relative overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
        {coverSrc ? (
          <img
            alt={album.name}
            src={coverSrc}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 bg-white/50 rounded-2xl flex items-center justify-center">
              <FolderOpen className="w-10 h-10 text-gray-400" />
            </div>
          </div>
        )}
        
        {/* Image Count Badge */}
        {album.imageCount !== undefined && album.imageCount > 0 && (
          <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-sm text-white px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1">
            <Image className="w-3 h-3" />
            {album.imageCount}
          </div>
        )}
      </div>
      
      {/* Content */}
      <div className="p-3">
        <h3 className="text-sm font-medium text-gray-900 group-hover:text-blue-600 transition-colors truncate">
          {album.name}
        </h3>
        
        {album.description && (
          <p className="text-xs text-gray-500 mt-0.5 line-clamp-1">
            {album.description}
          </p>
        )}
        
        {album.dateRange && (
          <p className="text-xs text-gray-500">
            {formatDateRange(album.dateRange)}
          </p>
        )}
        
        <div className="flex items-center justify-between mt-2">
          <span className="text-[10px] text-gray-400">
            {album.imageCount || 0} photos
          </span>
        </div>
      </div>
    </Link>
  )
}